module.exports = __webpack_public_path__ + "static/media/b3.cf6d7df.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chenlong/b3.mp3
// module id = ntk1
// module chunks = 0